<template>
  <div>
    <div id="logo-container">
      <router-link to="/">
        <img
          id="logo"
          src="../assets/Logo.png"
          alt="Logo"
          style="margin: auto"
        />
      </router-link>
    </div>

    <div id="search-and-logout-wrapper">
      <div id="search-area" v-if="signedIn && $route.name === 'home'">
        <input
          type="text"
          placeholder="search keywords"
          id="search"
          v-on:keyup="setFilterText()"
        />
      </div>

      <div id="sign-out-button-wrapper">
        <button
          id="sign-out-button"
          class="button-large"
          @click="signOut"
          v-if="signedIn"
        >
          Sign Out
        </button>
      </div>
    </div>

    <div id="sign-up-sign-in-button-wrapper">
      <button
        id="sign-up-button"
        class="button-large"
        @click="showSignUpModal"
        v-if="!signedIn"
      >
        Sign Up
      </button>

      <button
        id="sign-in-button"
        class="button-large"
        @click="showSignInModal"
        v-if="!signedIn"
      >
        Sign In
      </button>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { getAuth, signOut } from "firebase/auth";
import store from "../store";
import { defaultNote } from "../store";

export default {
  name: "Header",
  components: {},

  setup() {
    let signedIn = computed(function () {
      return store.state.user !== undefined && store.state.user !== null;
    });

    return {
      signedIn,
    };
  },

  methods: {
    showSignUpModal() {
      this.$emit("show-sign-up-modal");
    },

    showSignInModal() {
      this.$emit("show-sign-in-modal");
    },

    signOut() {
      console.log("signing out");
      const auth = getAuth();
      signOut(auth)
        .then(() => {
          console.log("signing out");
          store.commit("setNotes", []);
          store.commit("setActiveNote", { ...defaultNote });
          store.commit("logout");
        })
        .catch((error) => {});
    },

    setFilterText() {
      let text = document.getElementById("search").value.toLowerCase();
      store.commit("setFilterText", text);
    },
  },
};
</script>

<style>
#header {
  margin: 1rem 1rem 1rem 1rem;
  display: grid;
  display: -webkit-flex;
  display: -webkit-box-flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}

#logo-container {
  width: 50%;
}

#logo {
  width: 100%;
}

#search-and-logout-wrapper {
  display: flex;
  margin-left: auto;
}

#search-area {
  align-self: center;
  -webkit-align-self: center;
  -ms-flex-item-align: center;
}

#search {
  border-radius: 100px;
  border: 0px;
  padding: 2px 10px;
  background-color: hsl(174, 72%, 36%);
  color: hsl(174, 72%, 76%);
  height: 1.5rem;
  -webkit-text-fill-color: hsl(174, 72%, 76%);
}

#search:focus {
  outline: none;
}

#sign-up,
#sign-in,
#sign-out {
  display: none;
  z-index: 10;
}

#sign-up-sign-in-button-wrapper {
  align-self: center;
  -webkit-align-self: center;
  -ms-flex-item-align: center;
}

#sign-out-button-wrapper {
  align-self: center;
  -webkit-align-self: center;
  -ms-flex-item-align: center;
}

#sign-up-button,
#sign-in-button,
#sign-out-button {
  align-self: center;
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  height: 2rem;
  background-color: hsl(174, 72%, 76%);
}

#sign-up-button:hover,
#sign-in-button:hover,
#sign-out-button:hover {
  align-self: center;
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  height: 2rem;
  background-color: hsl(174, 72%, 56%);
}

#sign-up-button:active,
#sign-in-button:active,
#sign-out-button:active {
  align-self: center;
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  height: 2rem;
  background-color: hsl(174, 72%, 46%);
}

@media (max-width: 715px) {
  #logo-container {
    width: 100%;
  }

  #sign-up-sign-in-button-wrapper {
    width: 100%;
  }

  #search-and-logout-wrapper {
    margin: auto;
  }
}

@media (max-width: 390px) {
  #search-area {
    width: 60%;
  }

  #search {
    width: 80%;
  }

  #sign-out-button-wrapper {
    width: 40%;
  }

  #sign-out-button {
    width: 90%;
    margin-left: 0.5rem;
  }
}

@media (max-width: 290px) {
  #search-area {
    width: 100%;
  }

  #search {
    box-sizing: border-box;
    margin: auto;
  }

  #sign-out-button-wrapper {
    width: 100%;
  }

  #sign-out-button {
    box-sizing: border-box;
    margin: 0.5rem auto 0;
  }
}

@media (max-width: 260px) {
  #sign-in-button,
  #sign-up-button {
    margin-top: 0.5rem;
  }
}
</style>